import React from 'react';

import Button from '../../../../../../components/Button';
import Modal from '../../../../../../components/Modal';
import { typeAction } from '../../Utils/typeAction';

interface IFlightsModal {
  setModalState: (type: typeAction) => () => Promise<void>;
  modalVisible: boolean;
  modalVar: typeAction;
  onChangeFlightsBy: (type: typeAction, setValue?: any) => () => Promise<void>;
  modal: any;
}

export const FlightsModal = (props: IFlightsModal) => {
  const { setModalState, modalVisible, modalVar, onChangeFlightsBy, modal } = props;

  return (
    <Modal
      id="club15-help-modal"
      open={modalVisible}
      onClose={setModalState(modalVar as typeAction)}
      actions={[
        <Button
          key="button-cancel"
          onClick={setModalState(modalVar as typeAction)}
          variant="outlined"
          color="primary"
          fullWidth={true}
        >
          CANCEL
        </Button>,
        <Button
          key="button-agree"
          onClick={onChangeFlightsBy(modalVar as typeAction)}
          variant="contained"
          color="primary"
          fullWidth={true}
        >
          AGREE
        </Button>
      ]}
      {...modal}
    />
  );
};
